const LABELS = {
  affinity: ['Agency or partner access', 'This agency or partner code must be active.'],
  options: ['Policy options available', 'Resolve the quote rejections before purchase.'],
  prices: ['Prices are current', 'Update price before purchase.'],
  dates: ['Policy dates reviewed', 'Review the effective dates before purchase.'],
  data: ['Required data received', 'Complete the outstanding data pulls.'],
  mvr: ['Driving history (MVR) checked', 'Complete the required driving history checks.'],
  vins: ['VINs validated', 'Validate the vehicle identification numbers.'],
  underwriting: ['Underwriting requirements met', 'Complete the underwriting review and any required approval.'],
  drivingRecord: ['Driving records verified', 'Review the unverifiable driving record before purchase.'],
  licensed: ['Licensed to continue', 'You need permission and a license for this state to continue.']
};
const GROUPS = [
  ['quote', 'Quote & agency checks', ['affinity', 'options']],
  ['price', 'Price & effective-date checks', ['prices', 'dates']],
  ['reports', 'Required reports & vehicle checks', ['data', 'mvr', 'vins']],
  ['underwriting', 'Underwriting & driving records', ['underwriting', 'drivingRecord']],
  ['licensed', 'Licensed to continue', ['licensed']]
];
export const getQuoteChecklist = (states) =>
  GROUPS.map(([key, label, checks]) => ({
    key,
    label,
    complete: checks.every((check) => states[check] === true),
    hint: checks
      .filter((check) => states[check] !== true)
      .map((check) => LABELS[check][1])
      .join(' ')
  }));
